import { render, staticRenderFns } from "./MenuModular.vue?vue&type=template&id=eef6777a&scoped=true&"
import script from "./MenuModular.vue?vue&type=script&lang=js&"
export * from "./MenuModular.vue?vue&type=script&lang=js&"
import style0 from "./MenuModular.vue?vue&type=style&index=0&id=eef6777a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef6777a",
  null
  
)

export default component.exports